import axios from "axios";
import { toast } from "react-toastify";
import { CREDENTIALS_LIST } from "../../Store/Type";
import { api } from "./VaultApi";
import { encryptData, encryptVaultSecret } from "../../Componenets/Common/Encrypt-Decrypt";



const apiUrl = process.env.REACT_APP_API_URL;

const getUserId = () => {
  return (
    sessionStorage.getItem("USER_ID") ||
    localStorage.getItem("USER_ID") ||
    "003"
  );
};

export const GetCredentialsData = async ({
  dispatch,
  page = 1,
  limit = 10,
  sort_order = "D",
  sort_column = "cred_id",
  filter_category = "",
  search = "",
}) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);
  params.append("sort_order", sort_order);
  params.append("sort_column", sort_column);

  if (filter_category) {
    params.append("filter_category", filter_category);
  }

  if (search?.trim()) {
    params.append("search", search.trim());
  }

  try {
    const response = await api.get(
      `${apiUrl}/allCredentials?${params.toString()}`
    );

    dispatch({
      type: CREDENTIALS_LIST,
      payload: response?.data?.data || [],
      pageContext: response?.data?.pageContext || {},
    });

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetCredentialById = async (credId) => {
  try {
    const response = await api.get(`${apiUrl}/CredentialsById/${credId}`);
    return response?.data?.[0] || null;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SubmitCredentialData = async (values, credentialId) => {
  const userId = sessionStorage.getItem("USER_ID")
  
  const payload = {
    credential_name: values.credential_name || "",
    credential_type: values.credential_type || "",
    provider_name: values.provider_name || "",
    username: values.username || "",
    // secret_encrypted: values.secret || "",
    secret_encrypted: values.secret
  ? await encryptVaultSecret(values.secret)
  : "",
    notes: values.notes || "",
    expires_at: values.expires_at
      ? new Date(values.expires_at).toISOString()
      : null,
is_favorite: values.is_favorite ?? false,
    // created_by: sessionStorage.getItem("USER_ID") || "1",
    created_by:  "1",
    // is_sensitive: values?.is_sensitive,
    is_sensitive: values?.is_sensitive === true ? true : "false",
    user_id: getUserId(),
  };
    console.log(values,values?.is_sensitive,payload,"vvvvvvvvvvvv");


  const url = credentialId
    ? `${apiUrl}/updateCrentialData/${credentialId}`
    : `${apiUrl}/addCrentialData`;

  const method = credentialId ? "put" : "post";

  try {
    const response = await api({
      method,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // toast.success(
    //   credentialId
    //     ? "Credential updated successfully"
    //     : "Credential added successfully"
    // );
    toast.success(response?.data.message)

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

const handleError = (error) => {
  console.error("Error details:", error);

  let errorMessage = "An error occurred";

  if (error.response) {
    errorMessage =
      error?.response?.data?.message ||
      `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    errorMessage = "No response received from server";
  } else {
    errorMessage = error.message;
  }

  if (
    error.code === "ERR_NETWORK" ||
    error.code === "ERR_CONNECTION_REFUSED"
  ) {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }

  toast.error(errorMessage);
};

export const SendCredentialSecretKey = async (credId,otpPurpose) => {
  const userId = sessionStorage.getItem("USER_ID")
  try {
    const response = await api.post(
      `${apiUrl}/sendCredentialSecretKey`,
      {
        credId: String(credId),
        otp_purpose: otpPurpose,
        user_id: userId,
      }
    );

    if (response?.data?.message) {
      toast.success("SMS Sent Successfully to Registered Mobile Number");
    }

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateCredentialSecretKey = async (
  payload
) => {
  const userId = sessionStorage.getItem("USER_ID")
  const fullPayload = {...payload,user_id:userId}
  try {
    const response = await api.post(
      `${apiUrl}/validateCrentialSecretkey`,
      fullPayload
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const DeleteCredential = async (credId, dispatch, filters = {}) => {
  try {
    const userId = getUserId();

    const response = await api.delete(
      `${apiUrl}/deleteCredentialsById/${credId}/${userId}`
    );

    toast.success(response?.data?.message || "Credential deleted successfully");

    await GetCredentialsData({
      dispatch,
      ...filters,
    });

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const UpdateCredentialFavorite = async (credId, status) => {
  try {
    const payload = {
      status: status ? "true" : "false",
      user_id: sessionStorage.getItem("USER_ID"),
    };

    const response = await api.put(
      `${apiUrl}/updateCredentialsFavoriteStatus/${credId}`,
      payload
    );

    toast.success(status ? "Credential pinned" : "Credential unpinned");

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ShareCredential = async(id,email) => {  
  const userId = sessionStorage.getItem("USER_ID")
  const url = `${apiUrl}/sendCredentialMail`
  const payload = {credId:id,email:email,user_id:userId}
  try {
    const response = await api.post(url,payload)    
    toast.success(response?.data.message)
    return response?.data
  } catch(error) {
    console.error('Error in sharing the credential',error)
  }
}

export const ShareSensCredential = async(otp,id,email) => {
  const userId = sessionStorage.getItem("USER_ID")
  const url = `${apiUrl}/validateMailCredentialSecretKey`
  const encryptedOtp = await encryptVaultSecret(otp)
  const payload = {otp:encryptedOtp,cred_id:id,user_id:userId,email:email}
  try {
    const response = await api.post(url,payload)
    console.log(response,"response")
    toast.success(response?.data.message)
    return response?.data
  } catch(error) {
    console.error('Error in sharing the credential',error)
  }
}

export const EditSensCredential = async(otp, values, credentialId) => {
  const userId = sessionStorage.getItem("USER_ID")
  const payload = {
    credential_name: values.credential_name || "",
    credential_type: values.credential_type || "",
    provider_name: values.provider_name || "",
    username: values.username || "",
  secret_encrypted: values.secret
  ? await encryptVaultSecret(values.secret)
  : "",
    notes: values.notes || "",
    expires_at: values.expires_at
      ? new Date(values.expires_at).toISOString()
      : null,
is_favorite: values.is_favorite ?? false,
    // created_by: sessionStorage.getItem("USER_ID") || "1",
    created_by:  "1",
    is_sensitive: values?.is_sensitive,
    user_id:userId,
    otp: otp
  };

  const url = `${apiUrl}/validateUpdateCredentialSecretKey/${credentialId}`

  const method = "put";

  try {
    const response = await api({
      method,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });

    toast.success( "Credential updated successfully");

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
}

export const DeleteSensCredential = async (credId, dispatch,filters={},otp) => {
  try {
    // const userId = getUserId();
    const userId = sessionStorage.getItem("USER_ID")
    const payload = {
        data: {
          user_id: userId,
          otp: otp
        }
      }

    const response = await api.delete(
      `${apiUrl}/validateDeleteCredentialSecretKey/${credId}`,payload
    );

    await GetCredentialsData({
      dispatch,
      ...filters,
    });

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const ToggleCredential = async(credId,status) => {
  try {
    // const userId = getUserId();
    const userId = sessionStorage.getItem("USER_ID")
    const payload = {
    status:status,
    user_id:userId,
}

    const response = await api.put(
      `${apiUrl}/updateCredSensitiveStatus/${credId}`,payload
    );


    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
}
export const ToggleSensCredential = async(credId,status,otp) => {
  
try {
    // const userId = getUserId();
    const userId = sessionStorage.getItem("USER_ID")
    const payload = {
    status:status,
    user_id:userId,
    otp:otp
}

    const response = await api.put(
      `${apiUrl}/validateCredentialSensitiveStatus/${credId}`,payload
    );


    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
}